import { useEffect, useRef, useState } from "react";

export default function useDetailTableHeight(data, error) {
  const hostRef = useRef(null);
  const [height, setHeight] = useState(400);
  useEffect(() => {
    const host = hostRef.current;
    if (!host) return undefined;
    const header = host.querySelector(".ant-table-header");
    const resize = () => {
      // Reserve room for the horizontal scrollbar when either panel is narrow.
      if (host.clientHeight) setHeight(Math.max(1, host.clientHeight - (header?.offsetHeight || 80) - 20));
    };
    const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(resize);
    observer?.observe(host);
    if (header) observer?.observe(header);
    window.addEventListener("resize", resize);
    resize();
    return () => { observer?.disconnect(); window.removeEventListener("resize", resize); };
  }, [data, error]);
  return [hostRef, height];
}
